import React, {memo} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import cl from 'classnames';
import Footer from '../Footer/Footer';
import {ROUTES} from '../../configs/routes';
import ContentPreloader from '../ContentPreloader';
import HeadTools from '../HeadTools';

import './CommonPageWrap.less';

function CommonPageWrap({
  className, contentClass, hideSidebar, id, loader, router, children, breadCrumbs, title, titleRightComponent,
  hideHeadTools, hideBreadCrumbs, pageClass,
}) {
  if (router.location.pathname === ROUTES.ROOT.route && loader) {
    return <div />;
  }

  return (
    <div
      className={cl(`common-page-wrap ${className}`, {
        'common-page-wrap--full': hideSidebar,
      })}
      id={id}
    >
      <div className={`app-content has-header has-footer ${contentClass}`}>
        {!loader && (
          <>
            {!hideHeadTools && (
              <HeadTools
                titleRightComponent={titleRightComponent}
                title={title}
                breadCrumbs={breadCrumbs}
                hideBreadCrumbs={hideBreadCrumbs}
              />
            )}
            <div className={`app-content_page ${pageClass}`}>
              {children}
            </div>
          </>
        )}
        {loader && (<ContentPreloader />)}
      </div>
      <Footer />
    </div>
  );
}

CommonPageWrap.defaultProps = {
  contentClass: '',
  className: '',
  id: '',
  pageClass: '',
  router: {},
  hideSidebar: false,
  hideHeadTools: false,
  loader: false,
};

CommonPageWrap.propTypes = {
  contentClass: PropTypes.string,
  pageClass: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  hideSidebar: PropTypes.bool,
  hideHeadTools: PropTypes.bool,
  loader: PropTypes.bool,
  router: PropTypes.shape({}),
};

function mapStateToProps({rPages, router}) {
  return {
    router,
    hideSidebar: rPages.hideSidebar,
  };
}

export default connect(mapStateToProps, null)(memo(CommonPageWrap));
